module.exports = __webpack_public_path__ + "static/media/googlewallet.d6395ad1.svg";